import { FC, Fragment, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import useAppPermission from "hooks/useAppPermission";
import { apiFormAccessAllow } from "apis";
import { AppScroll } from "components";
import useAppSelector from "hooks/useAppSelector";


interface AdminMenuProps {
}

const menus = [
    {
        label: "Tổng quan",
        iconClass: "fa fa-solid fa-chart-column",
        url: "/administrator/dashboard.html",
        permissionCode: null
    },
    {
        label: "Ngôn ngữ",
        iconClass: "fa-solid fa-globe cursor-pointer",
        url: "/administrator/locale.html",
        permissionCode: "admin"
    },
    {
        label: "Vai trò",
        iconClass: "fa-solid fa-chart-simple",
        url: "/administrator/role.html",
        permissionCode: "admin.role"
    },
    {
        label: "Quyền",
        iconClass: "fa-solid fa-folder-tree",
        url: "/administrator/permission.html",
        permissionCode: "admin.permission"
    },
    {
        label: "Người dùng",
        iconClass: "fa-solid fa-user-doctor",
        url: "/administrator/user.html",
        permissionCode: "admin.user"
    },
    {
        label: "Nhóm người dùng",
        iconClass: "fa-solid fa-users",
        url: "/administrator/group-user.html",
        permissionCode: "admin.user"
    },
    {
        label: "Thư viện",
        iconClass: "fa-solid fa-folder-open",
        url: "/administrator/library.html",
        permissionCode: "admin.library"
    },
    {
        label: "Cấu hình",
        iconClass: "fa-solid fa-gear",
        url: "/administrator/config.html",
        permissionCode: "admin.config"
    },
    {
        label: "Trạng thái",
        iconClass: "fa-solid fa-user-pen",
        url: "/administrator/status.html",
        permissionCode: "admin"
    },
    {
        label: "Quy trình",
        iconClass: "fa-solid fa-chart-diagram",
        url: "/administrator/workflow.html",
        permissionCode: "admin"
    },
    {
        label: "Quản lý Form",
        iconClass: "fa-solid fa-pen-to-square",
        url: "/administrator/form.html",
        permissionCode: "admin"
    },
    {
        label: "Module",
        iconClass: "fa-brands fa-opencart",
        url: "/administrator/module.html",
        permissionCode: "admin"
    },
    {
        label: "Layout",
        iconClass: "fa-solid fa-table-columns",
        url: "/administrator/layout.html",
        permissionCode: "admin"
    },
    {
        label: "Quản lý Trang",
        iconClass: "fa-solid fa-pager",
        url: "/administrator/page.html",
        permissionCode: "admin"
    },
];

const AdminMenu: FC<AdminMenuProps> = () => {
    useEffect(() => {
        apiFormAccessAllow();
    }, [])

    const { pathname } = useLocation();
    const { allow } = useAppPermission();

    const [scrollTop, setScrollTop] = useState<number>(0);
    const forms = useAppSelector(state => state.form.list.accessAllow);

    return (
        <Fragment>
            <AppScroll
                className={`flex-1 p-0 lg:p-4 space-y-2 overflow-y-auto overflow-x-hidden group-[.sidebar-open]:p-4`}
                onScroll={(e) => {
                    setScrollTop(e.currentTarget.scrollTop);
                }}
            >
                {
                    menus
                        .filter(menu => !menu.permissionCode || allow(menu.permissionCode))
                        .map((menu, i) => {
                            const isActive = pathname.replace(/\.html$/, "").includes(menu.url.replace(/\.html$/, ""));
                            return <Link
                                key={i}
                                to={menu.url}
                                className={`
                                    group/menu-item
                                    whitespace-nowrap
                                    block px-2 py-2 rounded text-gray-800 transition-colors 
                                    ${isActive ? "bg-blue-500 group-[.sidebar-open]:text-white text-white hover:text-white" : "hover:bg-blue-100"}
                                `}
                            >
                                <span className="inline-block w-7 text-center">
                                    <i className={menu.iconClass} />
                                </span>
                                <span
                                    className={`
                                        opacity-0
                                        overflow-hidden transform transition-all duration-300 
                                        lg:opacity-0
                                        group-hover/menu-item:opacity-100

                                        !duration-0 
                                        group-hover/menu-item:fixed 
                                        group-hover/menu-item:ml-[25px] 
                                        group-hover/menu-item:-mt-[${scrollTop + 5}px] 
                                        group-hover/menu-item:bg-white 
                                        group-hover/menu-item:shadow 
                                        group-hover/menu-item:px-[20px] 
                                        group-hover/menu-item:rounded 
                                        group-hover/menu-item:py-[5px] 
                                        group-hover/menu-item:text-gray-800
                                        group-hover/menu-item:z-[51]
                                        
                                        group-[.sidebar-open]:lg:opacity-100
                                        group-[.sidebar-open]:lg:relative
                                        group-[.sidebar-open]:lg:shadow-none
                                        group-[.sidebar-open]:lg:text-inherit
                                        group-[.sidebar-open]:lg:p-2
                                        group-[.sidebar-open]:lg:ml-0
                                        group-[.sidebar-open]:lg:bg-transparent
                                        ${isActive ? "  group-[.sidebar-open]:text-white text-white group-[.sidebar-open]:hover:text-white " : ""}
                                    `}
                                >
                                    {menu.label}
                                </span>
                            </Link>
                        })
                }
                {/* {forms.length > 0 && <div className="flex items-center">
                    <div className="flex-1 border-t"></div>
                    <span className="px-3 text-gray-500 text-sm">Dữ liệu</span>
                    <div className="flex-1 border-t"></div>
                </div>}
                {
                    forms.map((form, i) => {
                        const url = `/administrator/data/${form.code}.html`;
                        const isActive = pathname.replace(/\.html$/, "").includes(url.replace(/\.html$/, ""));
                        return <Link
                            key={i}
                            to={url}
                            className={`
                                    group/menu-item
                                    whitespace-nowrap
                                    block px-2 py-2 rounded text-gray-800 transition-colors 
                                    ${isActive ? "bg-blue-500 group-[.sidebar-open]:text-white text-white hover:text-white" : "hover:bg-blue-100"}
                                `}
                        >
                            <span className="inline-block w-7 text-center">
                                <i className="fa-solid fa-circle" />
                            </span>
                            <span
                                className={`
                                        opacity-0
                                        overflow-hidden transform transition-all duration-300 
                                        lg:opacity-0
                                        group-hover/menu-item:opacity-100

                                        !duration-0 
                                        group-hover/menu-item:fixed 
                                        group-hover/menu-item:ml-[25px] 
                                        group-hover/menu-item:-mt-[${scrollTop + 5}px] 
                                        group-hover/menu-item:bg-white 
                                        group-hover/menu-item:shadow 
                                        group-hover/menu-item:px-[20px] 
                                        group-hover/menu-item:rounded 
                                        group-hover/menu-item:py-[5px] 
                                        group-hover/menu-item:text-gray-800
                                        group-hover/menu-item:z-[51]
                                        
                                        group-[.sidebar-open]:lg:opacity-100
                                        group-[.sidebar-open]:lg:relative
                                        group-[.sidebar-open]:lg:shadow-none
                                        group-[.sidebar-open]:lg:text-inherit
                                        group-[.sidebar-open]:lg:p-2
                                        group-[.sidebar-open]:lg:ml-0
                                        group-[.sidebar-open]:lg:bg-transparent
                                        ${isActive ? "  group-[.sidebar-open]:text-white text-white group-[.sidebar-open]:hover:text-white " : ""}
                                    `}
                            >
                                {form.name}
                            </span>
                        </Link>
                    })
                } */}
            </AppScroll>
        </Fragment>
    );
};
export default AdminMenu;
